<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <div :style="style.innerContainer">
      <template v-for="(itemState, index) in itemStates">
        <TagTogglePrimary
          v-on="$listeners"
          v-model="itemState[stateKey]"
          :disabled="disabled"
          :freeze="freeze"
          :key="index"
          @change="state => onChange(state, index)"
          :style="style.tag"
        >
          {{ itemState[labelKey] }}
        </TagTogglePrimary>
      </template>
    </div>
  </div>
</template>

<script>
  import TagTogglePrimary from '@modules/v2/tag/tag-toggle-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'TagToggleListPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change-selected-items',
    },
    components: {
      TagTogglePrimary,
    },
    props: {
      /**
       * The "states" prop is expected to be an array of objects
       * with the following structure. The keys of label and selected
       * can be changed by setting labelKey and stateKey respectively.
       * [
       *   { label: 'Item 1', selected: false },
       *   { label: 'Item 2', selected: true },
       *   ...
       * ]
      **/
      //states: { type: Array, required: true },
      vmodelValue: {
        type: Array,
        required: false,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      freeze: {
        type: Boolean,
        required: false,
        default: false,
      },
      idKey: {
        type: [String],
        required: false,
        default: 'id',
      },
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      labelKey: {
        type: String,
        required: false,
        default: 'label',
      },
      stateKey: {
        type: String,
        required: false,
        default: 'selected',
      },
    },
    data: function () {
      return {
        itemStates: this.items
          .reduce((result, elem) => {
            result.push({
              [this.idKey]: elem[this.idKey],
              [this.labelKey]: elem[this.labelKey],
              [this.stateKey]: this.vmodelValue.includes(elem[this.idKey]),
            });
            return result;
          }, []),
        selectedItems: [...this.vmodelValue],
        style: {
          container: {
            alignItems: 'flex-start',
            display: 'flex',
            justifyContent: 'flex-start',
          },
          innerContainer: {
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
          },
          tag: {
            padding: Layout.space.xs,
          },
        },
      };
    },
    methods: {
      onChange: function (state, index) {
        this.selectedItems = this.itemStates
          .filter(elem => elem[this.stateKey])
          .map(elem => elem[this.idKey]);
        this.$emit('change-selected-items', this.selectedItems);
        if (state) {
          this.$emit('select', index);
        } else {
          this.$emit('unselect', index);
        }
      },
      updateStates: function () {
        this.itemStates = this.items
          .reduce((result, elem) => {
            result.push({
              [this.idKey]: elem[this.idKey],
              [this.labelKey]: elem[this.labelKey],
              [this.stateKey]: this.vmodelValue.includes(elem[this.idKey]),
            });
            return result;
          }, []);
      },
    },
    watch: {
      vmodelValue: {
        handler: function (newVal, oldVal) {
          this.updateStates();
        },
        deep: true,
      },
      items: {
        handler: function (newVal, oldVal) {
          this.updateStates();
        },
        deep: true,
      },
    },
  };
</script>
